import { Component, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ServiceType } from '@cpw/domain';
import { SelectOption } from '@pf/shared-common';
import { SharedUiModule } from '@pf/shared-ui';

@Component({
    selector: 'cpw-service-type-select',
    standalone: true,
    imports: [SharedUiModule, ReactiveFormsModule],
    template: `
        <pf-select
            class="pf-full-width"
            label="Speed"
            pfStyle="block"
            [data]="serviceTypeOptions"
            [control]="serviceTypeControl"
            [selectedOption]="selectedServiceType()"
            (selected)="onSelected($event)"></pf-select>
    `,
})
export class CpwServiceTypeSelectComponent {
    readonly serviceTypeOptions: SelectOption[] = [
        { label: 'FedEx Ground', value: ServiceType.FedExGround },
        { label: 'Priority Overnight', value: ServiceType.PriorityOvernight },
        {
            label: 'International Priority',
            value: ServiceType.InternationalPriority,
        },
        {
            label: 'FedEx Freight Priority',
            value: ServiceType.FedExFreightPriority,
        },
        {
            label: 'FedEx Freight Economy',
            value: ServiceType.FedExFreightEconomy,
        },
    ];

    serviceTypeControl = new FormControl(ServiceType.FedExGround);
    selectedServiceType = signal<SelectOption>(this.serviceTypeOptions[0]);

    serviceTypeChanged = output<ServiceType>();

    protected onSelected($event: SelectOption) {
        this.selectedServiceType.set($event);
        this.serviceTypeChanged.emit($event.value as ServiceType);
    }
}
